import React from 'react';
import { httpGet, httpPost } from '../../utils/http';
var createContext = React.createContext,
  useContext = React.useContext;
var TineUserFeedbackContext = createContext(null);
export var TineUserFeedbackProvider = function (props) {
  var endpoint = props.endpoint,
    siteKey = props.siteKey,
    contentKey = props.contentKey,
    contentTitle = props.contentTitle,
    referer = props.referer;
  var config = {
    endpoint: endpoint,
    siteKey: siteKey,
    contentKey: contentKey,
    contentTitle: contentTitle,
    referer: referer,
    format: 'json'
  };
  var value = {
    upvoteComment: upvoteComment.bind(null, config),
    postComment: postComment.bind(null, config),
    fetchComments: fetchComments.bind(null, config)
  };
  return /*#__PURE__*/React.createElement(TineUserFeedbackContext.Provider, {
    value: value
  }, props.children);
};
export var useTineUserFeedback = function () {
  return useContext(TineUserFeedbackContext);
};
var upvoteComment = function (config, commentId) {
  var url = "".concat(config.endpoint, "/vote/").concat(config.siteKey, "/comment/").concat(commentId, "/1?format=json");
  return httpPost(url, {
    commentId: commentId
  }, '').catch(function (error) {
    return error;
  });
};
var postComment = function (config, body) {
  var payload = {
    key: config.contentKey,
    contenttitle: config.contentTitle,
    comment: body.comment,
    email: body.email,
    emailnotify: body.emailnotify ? 1 : 0,
    firstname: body.firstname,
    format: 'json'
  };
  var queryUrl = "".concat(config.endpoint, "/").concat(config.siteKey, "/").concat(config.contentKey);
  var referer = "http://www.tine.no".concat(body.url);
  if (body.parentCommentId) {
    payload.parentcommentid = body.parentCommentId;
    payload.contentTitle = "SV: ".concat(config.contentTitle);
  }
  return httpPost(queryUrl, jsonToEncodedString(payload), {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    Referer: referer
  }).catch(function (error) {
    return error;
  });
};
export var fetchComments = function (config) {
  var URL = "".concat(config.endpoint, "/").concat(config.siteKey, "/").concat(config.contentKey, "/desc?format=json&newFirst=false");
  return httpGet(URL, '', {
    cache: 'no-store'
  }).catch(function () {
    return [];
  });
};
function jsonToEncodedString(json) {
  return Object.keys(json).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(json[key]));
  }).join('&');
}